import { Routes, Route, BrowserRouter } from "react-router-dom"
import TimelinePageOne from 'components/TimelinePageOne';
import 'i18n';

function App() {

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/:param?" element={<TimelinePageOne />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
